import { PriorityHigh, Restore, Save } from "@mui/icons-material";
import { IconButton, Paper, Stack, Typography } from "@mui/material";
import _ from "lodash";
import React from "react";
import { useFormContext, useFormState } from "react-hook-form";
import RestoreProcessingDialog from "../../useDialogs/RestoreProcessingDialog";
import { useDialogs } from "../../useDialogs/useDialogs";
import { useUpdateReview } from "../OrionQueries";

const FormActionBar: React.FC = () => {
  const dialogs = useDialogs();
  const { reset } = useFormContext();
  const { dirtyFields } = useFormState();
  const isDirty = _.keys(dirtyFields).length > 0;
  const { isPending } = useUpdateReview();

  return (
    <Paper className="sticky bottom-0 left-0 right-0 w-full border-t shadow-lg border-[#4c4fa2] border border-solid	rounded-lg">
      <div className="px-2 flex justify-between items-center">
        <div className="flex gap-1">
          <IconButton
            type="submit"
            disabled={!isDirty}
            aria-label="Save"
            color="primary"
          >
            <Save />
          </IconButton>
          <IconButton
            disabled={!isDirty || isPending}
            type="button"
            color="primary"
            onClick={() =>
              dialogs.open(RestoreProcessingDialog, {
                reset: reset,
              })
            }
          >
            <Restore />
          </IconButton>
        </div>

        {isDirty && (
          <Stack alignItems="center" direction="row" className="text-[#4c4fa2]">
            <PriorityHigh fontSize="small" />
            <Typography className="text-sm">
              Changements non enregistrés
            </Typography>
          </Stack>
        )}
      </div>
    </Paper>
  );
};

export default FormActionBar;
